import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 {...{
      "id": "features-of-rnb-backend-booking-plugin"
    }}>{`Features of RnB Backend Booking Plugin`}</h3>
    <ul>
      <li parentName="ul">{`Unlimited booking products`}</li>
      <li parentName="ul">{`Multiple inventories with multiple quantities`}</li>
      <li parentName="ul">{`Product availability control`}</li>
      <li parentName="ul">{`Inventory management`}</li>
      <li parentName="ul">{`Control order status`}</li>
      <li parentName="ul">{`Order cancellation & availability restore`}</li>
      <li parentName="ul">{`Local & global product setting`}</li>
      <li parentName="ul">{`Hour based booking & calendar blocking`}</li>
      <li parentName="ul">{`Hour based pricing`}</li>
      <li parentName="ul">{`General pricing`}</li>
      <li parentName="ul">{`Day based pricing`}</li>
      <li parentName="ul">{`Monthly pricing`}</li>
      <li parentName="ul">{`Day range pricing`}</li>
      <li parentName="ul">{`Kilometer based pricing`}</li>
      <li parentName="ul">{`Price discount(Percentage/Fixed)`}</li>
      <li parentName="ul">{`Price breakdown`}</li>
      <li parentName="ul">{`Coupon based discount`}</li>
      <li parentName="ul">{`Unlimited Resources (Payable/Free)`}</li>
      <li parentName="ul">{`Unlimited Categories with Quantity(Payable/Free)`}</li>
      <li parentName="ul">{`Category (Mandatory/Optional)`}</li>
      <li parentName="ul">{`Category Cost(Per day/OneTime)`}</li>
      <li parentName="ul">{`Security Deposit`}</li>
      <li parentName="ul">{`Deposit Cost(Mandatory/Optional)`}</li>
      <li parentName="ul">{`Date format`}</li>
      <li parentName="ul">{`Late hour management`}</li>
      <li parentName="ul">{`Max & Min booking days`}</li>
      <li parentName="ul">{`Initial block days`}</li>
      <li parentName="ul">{`Holidays Configuration`}</li>
      <li parentName="ul">{`Weekend Configuration`}</li>
      <li parentName="ul">{`Opening & Closing Hours`}</li>
    </ul>
    <h3 {...{
      "id": "integrations"
    }}>{`Integrations`}</h3>
    <ul>
      <li parentName="ul">{`Full calendar order report`}</li>
      <li parentName="ul">{`Google calendar integration`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      